<template>
    <div class="visual">
        <div class="visual__inner">
            <Title :title="title" :custom="'gn-title'" class="title"></Title>
            <div class="map">
                <sequential-entrance delay="250" animation="countryIn">
                <a v-for="country in countrys"
                    :key="country.name"
                    href="#"
                    v-scroll-to="'#' + country.name"
                    :class="['country', country.name]">
                    <p v-html="country.content"></p>
                </a>
                </sequential-entrance>
            </div>
            <p class="desc-main" v-html="$t('globalnetwork.title')"></p>
            <p class="desc-sub" v-html="$t('globalnetwork.desc')"></p>
        </div>
        <div v-scroll-to="'#content'" class="scroll-down"><span class="is-lato">SCROLL DOWN</span></div>
    </div>
</template>

<script>
import Title from '@/components/common/Title'
export default {
    name: 'Visual',
    components: { Title },
    props: [ 'title', 'background' ],
    data: function () {
        return {
            countrys: [
                {name: 'uk', content: 'UNITED<br>KINGDOM'},
                {name: 'de', content: 'GERMANY'},
                {name: 'kr', content: 'KOREA'},
                {name: 'jp', content: 'JAPAN'}
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes country {
    0% {opacity: 0; transform: scale(0.3);}
    50% {opacity: 1; transform: scale(1);}
    100% {opacity: 0; transform: scale(1.3);}
}
@keyframes country-visible {
    0% {transform: translateY(-40px); opacity: 0;}
    100% {transform: translateY(0); opacity: 1;}
}
.countryIn {
    position: relative;
    animation: country-visible 1200ms;
}
@keyframes scroll-down {
    0% {opacity: 0; transform: translate(-50%, -60px)}
    100% {opacity: 1; transform: translate(-50%, 0)}
}
.visual {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 920px;
    background: #ddd;
    background-size: cover;
    background-image: url(../../assets/image/background/background_globalnetwork.jpg);
    background-position: center bottom;

    &::before {
        @include gradient;
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.5;
    }
    .scroll-down {
        display: block;
        position: absolute;
        bottom: -40px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        animation: scroll-down 1000ms backwards;
        span {
            position: relative;
            color: #fff;
            font-weight: 700;
            font-size: 12px;
            line-height: 12px;
            &::after {
                content: '';
                display: block;
                margin: 10px auto 0;
                width: 1px;
                height: 40px;
                background: #fff;
                opacity: 0.5;
            }
        }
        &::after {
            content: '';
            display: block;
            margin: 0 auto;
            width: 1px;
            height: 40px;
            background: #e0e0e0;
        }

    }
    &__inner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        // padding: 190px 0 120px;
        text-align: center;
        margin: 0 auto;
    }
    @keyframes map-visible {
        0% {opacity: 0; transform: translateX(-50px);}
        100% { opacity: 1; transform: translateX(0);}
    }
    .map {
        position: relative;
        width: 767px;
        height: 341px;
        margin: 10vh auto 0;
        background-image: url(../../assets/image/common/global-map-02.png);
        background-repeat: no-repeat;
        background-origin: center;
        animation: map-visible 1200ms 400ms backwards;

        .country {
            position: absolute;
            top: 0;
            left: 0;
            width: 90px;
            height: 90px;
            border-radius: 50%;

            &::before {
                content: '';
                display: block;
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                animation: country 1400ms infinite;
            }

            &.uk,
            &.de,
            &.jp {
                background: rgba($color: #ea7a94, $alpha: 0.7);
                &::before {
                    background: rgba($color: #ea7a94, $alpha: 0.7);
                }
            }
            &.kr {
                background: rgba($color: #8d73c2, $alpha: 0.7);
                &::before {
                    background: rgba($color: #8d73c2, $alpha: 0.7);
                }
            }

            p {
                position: absolute;
                top: 50%;
                z-index: 1;
                width: 100%;
                color: #fff;
                font-weight: 700;
                font-size: 13px;
                text-align: center;
                transform: translateY(-50%);
            }
            &.uk {
                top: 10%;
                left: -3%;
                z-index: 1;
            }
            &.de {
                top: 22%;
                left: 6%;
            }
            &.kr {
                top: 33%;
                left: 33%;
                z-index: 1;
            }
            &.jp {
                top: 28%;
                left: 42%;
            }
        }
    }
    @keyframes visible-desc {
        0% {opacity: 0; transform: translateY(40px);}
        100% { opacity: 0.8; transform: translateY(0);}
    }
    .desc-main {
        margin-top: 7.5vh;
        color: #fff;
        font-size: 26px;
        line-height: 26px;
        letter-spacing: -1px;
        text-align: center;
        opacity: 0.8;
        animation: visible-desc 1000ms 500ms backwards;
    }
    .desc-sub {
        margin-top: 3vh;
        color: #fff;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -1px;
        text-align: center;
        opacity: 0.8;
        animation: visible-desc 1000ms 750ms backwards;
    }
}
@include under-tablet {
    .visual {
        min-height: 170vw;
        background-image: url(../../assets/image/background/background_globalnetwork_m.jpg);
        background-position: center;
        .scroll-down {
            bottom: -3vh;
            transform: translateX(-50%);
            cursor: pointer;
            animation: scroll-down 1000ms backwards;
            span {
                font-size: 3.4vw;
                line-height: 3.4vw;
                &::after {
                    height: 3vh;
                    margin-top: 2vw;
                }
            }
            &::after {
                height: 3vh;
            }
        }
        &__inner {
            width: 100%;
            // margin-top: 8vw;
            @keyframes map-visible-mobile {
                0% {opacity: 0; transform: translateY(-4vw);}
                100% { opacity: 1; transform: translateY(0);}
            }
            .map {
                position: relative;
                width: calc(100% - 90px);
                height: 50vw;
                margin-top: 8vw;
                background: url(../../assets/image/common/global-map-02.png) no-repeat center center;
                background-size: 100% auto;
                animation: map-visible-mobile 1200ms 400ms backwards;

                .country {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 18vw;
                    height: 18vw;
                    border-radius: 50%;

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        animation: country 1400ms infinite;
                    }

                    &.uk,
                    &.de,
                    &.jp {
                        background: rgba($color: #ea7a94, $alpha: 0.7);
                        &::before {
                            background: rgba($color: #ea7a94, $alpha: 0.7);
                        }
                    }
                    &.kr {
                        background: rgba($color: #8d73c2, $alpha: 0.7);
                        &::before {
                            background: rgba($color: #8d73c2, $alpha: 0.7);
                        }
                    }

                    p {
                        position: absolute;
                        top: 50%;
                        z-index: 1;
                        width: 100%;
                        color: #fff;
                        font-weight: 700;
                        font-size: 2.8vw;
                        text-align: center;
                        transform: translateY(-50%);
                    }
                    &.uk {
                        top: 8%;
                        left: -3%;
                        z-index: 1;
                    }
                    &.de {
                        top: 28%;
                        left: 9%;
                    }
                    &.kr {
                        top: 37%;
                        left: 33%;
                        z-index: 1;
                    }
                    &.jp {
                        top: 22%;
                        left: 46%;
                    }
                }
            }
            .desc-main {
                margin-top: 6vw;
                font-size: 4.4vw;
                line-height: 6vw;
            }
            .desc-sub {
                margin-top: 4vw;
                font-size: 3.6vw;
                line-height: 5vw;
            }
        }
        @keyframes visible-desc-m {
            0% {opacity: 0; transform: translateY(4vw);}
            100% { opacity: 0.8; transform: translateY(0);}
        }
        .desc-main {
            animation: visible-desc-m 1000ms 500ms backwards;
        }
        .desc-sub {
            animation: visible-desc-m 1000ms 750ms backwards;
        }
    }
}
@include mobile {
    .visual {
        &__inner {
            .map {
                width: calc(100% - 40px);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/globalnetwork/Visual.vue